export function resolveFieldData(obj: any, prop: string): any {
  let resolve;

  try {
    const arr = prop.split('.');
    while (arr.length) {
      obj = obj[arr.shift()];
    }
    resolve = obj;
  } catch (e) {
    // When the operation error-ed out
    // Mostly when the property you are trying to reach is undefined
    resolve = null;
  }
  return resolve;
}
